var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopUp = function SvgTopUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 16c0 3.3 2.687 6 6 6 3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6Zm6.665-3.313v2.635h2.636v1.33h-2.636v2.649h-1.33v-2.648h-2.649v-1.33h2.649v-2.636h1.33Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.752 19.997a9 9 0 1 1 8.643-10.371A6.974 6.974 0 0 0 16.5 9c-.909 0-1.777.173-2.574.488v-.196a3.355 3.355 0 0 0-.705-2.212 3.02 3.02 0 0 0-1.737-.952V4H9.508v2.156a3.129 3.129 0 0 0-1.411.784 2.642 2.642 0 0 0-.734 1.918 2.525 2.525 0 0 0 .804 1.946c.64.525 1.394.9 2.202 1.092a3.3 3.3 0 0 1 .377.116 6.972 6.972 0 0 0-.961 2.005 1.594 1.594 0 0 1-.32-.217 1.241 1.241 0 0 1-.366-.98v-.42h-1.99l-.1.266v.112a2.789 2.789 0 0 0 .833 2.226 3.52 3.52 0 0 0 1.66.867 7.06 7.06 0 0 0 .006.47V18h.282a6.97 6.97 0 0 0 .962 1.997Zm1.387-9.473a5.56 5.56 0 0 0-1.106-.406 3.838 3.838 0 0 1-1.299-.602.879.879 0 0 1-.282-.686 1.02 1.02 0 0 1 .282-.756c.249-.193.561-.282.875-.252a.977.977 0 0 1 .833.364c.242.317.362.709.339 1.106v.392h1.697c-.479.23-.928.512-1.339.84Z",
    fill: "#666"
  })));
};
export default SvgTopUp;